/**
 * Format date to India timezone (date only)
 * @param {string|Date} dateString - Date string or Date object
 * @returns {string} Formatted date string in DD/MM/YYYY format
 */
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  
  try {
    return new Date(dateString).toLocaleDateString('en-IN', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};

/**
 * Format date and time to India timezone
 * @param {string|Date} dateString - Date string or Date object
 * @returns {string} Formatted date and time string in DD/MM/YYYY HH:MM format
 */
export const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  
  try {
    return new Date(dateString).toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  } catch (error) {
    console.error('Error formatting date and time:', error);
    return 'Invalid Date';
  }
}; 